(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pokemon-game-covers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pokemon-game-covers')) {
    customElements.define('pokemon-game-covers', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.viewport = this.querySelector('.pokemon-covers__viewport');
        this.list = this.querySelector('.pokemon-covers__list');
        this.toggle = this.querySelector('.pokemon-covers__toggle');
        if (!this.viewport || !this.list || !this.toggle) return;
        this.initialized = true;
        const connection = {};
        this.connection = connection;
        const active = () => this.connection === connection && this.isConnected;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = Boolean(this.paused || this.motion.matches || this.viewport.contains(document.activeElement));
        this.visible = false;
        this.hovered = false;
        this.running = false;
        this.lastTime = null;
        this.position = 0;
        this.loopWidth = 0;
        this.hasOverflow = false;
        const duplicate = this.duplicate = this.list.cloneNode(true);
        duplicate.setAttribute('aria-hidden', 'true');
        duplicate.setAttribute('inert', '');
        duplicate.querySelectorAll('[data-shopify-editor-block]').forEach(item => item.removeAttribute('data-shopify-editor-block'));
        duplicate.querySelectorAll('[id]').forEach(item => item.removeAttribute('id'));
        duplicate.querySelectorAll('img').forEach(img => img.alt = '');
        this.viewport.append(duplicate);
        this.controller = new AbortController();
        const events = { signal: this.controller.signal };
        this.toggle.addEventListener('click', () => {
          this.paused = !this.paused;
          this.position = this.viewport.scrollLeft;
          this.update();
        }, events);
        this.viewport.addEventListener('pointerdown', () => this.pause(), events);
        this.viewport.addEventListener('focusin', () => this.pause(), events);
        this.viewport.addEventListener('wheel', () => this.pause(), { ...events, passive: true });
        this.viewport.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') { this.hovered = true; this.update(); }
        }, events);
        this.viewport.addEventListener('pointerleave', () => { this.hovered = false; this.update(); }, events);
        this.motion.addEventListener('change', () => { if (this.motion.matches) this.pause(); }, events);
        document.addEventListener('visibilitychange', () => this.update(), events);
        this.tick = time => {
          if (!active() || !this.running || !this.canRun()) return;
          this.frame = null;
          if (this.lastTime !== null) {
            this.position += Math.min(time - this.lastTime, 50) * 0.025;
            this.position %= this.loopWidth;
            this.viewport.scrollLeft = this.position;
          }
          this.lastTime = time;
          this.frame = requestAnimationFrame(this.tick);
        };
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            if (!active()) return;
            const entry = entries.find(item => item.target === this);
            if (!entry) return;
            this.visible = entry.isIntersecting;
            this.update();
          });
          this.observer.observe(this);
        } else {
          this.visible = true;
        }
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => { if (active()) this.measure(); });
          this.resizeObserver.observe(this.list);
          this.resizeObserver.observe(this.viewport);
        } else {
          window.addEventListener('resize', () => this.measure(), events);
        }
        this.measure();
      }
      measure() {
        if (!this.initialized || !this.isConnected) return;
        this.loopWidth = this.list.getBoundingClientRect().width;
        this.hasOverflow = this.loopWidth > this.viewport.clientWidth + 1;
        this.duplicate.style.display = this.hasOverflow ? '' : 'none';
        this.toggle.hidden = !this.hasOverflow;
        this.update();
      }
      canRun() {
        return this.initialized && this.isConnected && this.hasOverflow && !this.paused && !this.hovered && this.visible && !document.hidden;
      }
      pause() {
        if (!this.initialized) return;
        this.paused = true;
        this.update();
      }
      update() {
        if (!this.initialized || !this.isConnected) return;
        cancelAnimationFrame(this.frame);
        this.frame = null;
        this.running = false;
        this.lastTime = null;
        this.toggle.textContent = this.paused ? 'Play scrolling' : 'Pause scrolling';
        this.toggle.setAttribute('aria-label', this.paused ? 'Play game cover scrolling' : 'Pause game cover scrolling');
        this.dataset.paused = String(this.paused);
        if (this.canRun()) {
          this.position = this.viewport.scrollLeft;
          this.running = true;
          this.frame = requestAnimationFrame(this.tick);
        }
      }
      disconnectedCallback() {
        this.initialized = false;
        this.connection = null;
        this.running = false;
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        this.controller?.abort();
        this.duplicate?.remove();
        this.duplicate = null;
        this.frame = null;
        this.lastTime = null;
        if (this.toggle) this.toggle.hidden = true;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["retrolab-game-library"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('retrolab-library-marquee')) {

    customElements.define('retrolab-library-marquee', class extends HTMLElement {

      connectedCallback() {

        if (this.controller) return;

        this.controller = new AbortController();

        const signal = this.controller.signal;

        this.toggle = this.querySelector('[data-motion-toggle]');

        this.pauseLabel = this.querySelector('[data-pause-label]');

        this.resumeLabel = this.querySelector('[data-resume-label]');
        this.rows = [...this.querySelectorAll('[data-marquee-viewport]')];
        const rowContainer = this.querySelector('.rl-marquee__rows');
        this.motionPreference = matchMedia('(prefers-reduced-motion: reduce)');

        this.visible = false;

        this.userPaused = false;

        this.hoverPaused = false;

        this.touchPaused = false;

        this.manualMode = false;

        this.sync = () => {

          const enabled = this.dataset.motionEnabled !== 'false' && !this.motionPreference.matches;

          const animated = enabled && !this.manualMode;

          const paused = this.userPaused || this.manualMode;

          this.dataset.animated = String(animated);

          this.dataset.running = String(animated && !this.userPaused && !this.hoverPaused && !this.touchPaused && this.visible && !document.hidden);

          this.dataset.userPaused = String(paused);

          this.toggle.hidden = !enabled || this.rows.length === 0;

          this.pauseLabel.hidden = paused;

          this.resumeLabel.hidden = !paused;

        };

        this.toggle.addEventListener('click', () => {

          if (this.manualMode) {

            this.manualMode = false;

            this.userPaused = false;

            this.rows.forEach(row => { row.scrollLeft = 0; });

          } else {

            this.userPaused = !this.userPaused;

          }

          this.sync();

        }, { signal });

        rowContainer.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') { this.hoverPaused = true; this.sync(); }

        }, { signal });

        rowContainer.addEventListener('pointerleave', event => {
          if (event.pointerType === 'mouse') { this.hoverPaused = false; this.sync(); }

        }, { signal });

        rowContainer.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'mouse') { this.touchPaused = true; this.sync(); }

        }, { passive: true, signal });

        const releaseTouch = () => {

          if (this.touchPaused) { this.touchPaused = false; this.sync(); }

        };

        document.addEventListener('pointerup', releaseTouch, { passive: true, signal });

        document.addEventListener('pointercancel', releaseTouch, { passive: true, signal });

        this.addEventListener('focusin', event => {

          if (event.target.matches('[data-marquee-viewport]:focus-visible')) {
            this.manualMode = true;

            this.sync();

          }

        }, { signal });

        this.addEventListener('shopify:block:select', event => {

          const card = event.target.closest('.rl-marquee__card');

          if (!card || !this.contains(card)) return;

          this.manualMode = true;

          this.sync();

          const row = card.closest('[data-marquee-viewport]');

          row.scrollLeft += card.getBoundingClientRect().left - row.getBoundingClientRect().left;

        }, { signal });

        this.motionPreference.addEventListener('change', this.sync, { signal });

        document.addEventListener('visibilitychange', () => {

          if (document.hidden) this.touchPaused = false;

          this.sync();

        }, { signal });

        this.observer = new IntersectionObserver(entries => {

          this.visible = entries[0].isIntersecting;

          this.sync();

        }, { threshold: .01 });

        this.observer.observe(this);

        this.sync();

      }

      disconnectedCallback() {

        this.controller?.abort();

        this.observer?.disconnect();

        this.controller = null;

        this.dataset.running = 'false';

      }

    });

  }


  } catch(e) { console.error(e); }
})();
})();
